import { URLS } from "../API/API endpoints";
import axiosInstance from "../AxiosInstance";
import i18next from "i18next";

export const getVendors = async (user_id) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      user_id: user_id,
    };
    const response = await axiosInstance.post(URLS.GET_VENDORS, payload);

    // console.log("responsse data", response.data);

    return response.data?.result?.vendors;
  } catch (error) {
    return error;
  }
};

export const getVendorsList = async (user_id) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      user_id: user_id,
    };
    const response = await axiosInstance.post(URLS.GET_VENDORS_LIST, payload);

    // console.log("responsse data", response.data);

    return response.data?.result?.vendors;
  } catch (error) {
    return error;
  }
};

export const fetchAllVendors = async (user_id, limit, offset, text) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      user_id: user_id,
      limit: limit,
      offset: offset,
      name: text
    };
    const response = await axiosInstance.post(URLS.GET_VENDORS, payload);

    // console.log("responsse data", response.data);

    return response.data?.result?.vendors;
  } catch (error) {
    return error;
  }
};

export const createVendor = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.CREATE_VENDOR, payload);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateVendor = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.UPDATE_VENDOR, payload);
    return response;
  } catch (error) {
    return error;
  }
};

export const getPurchaseProducts = async (
  user_id,
  productName,
  limit = 10,
  offset = 0
) => {
  try {
    const payload = {
      user_id: user_id,
      product_name: productName,
      limit: limit,
      offset: offset,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };

    const response = await axiosInstance.post(URLS.SEARCH_PRODUCTS, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

// Supplier Payment APIS

export const getPaymentsList = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_PAYMENT_LIST, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getBillPaymentHistory = async (payload) => {
  try {
    const response = await axiosInstance.post(
      URLS.GET_BILL_PAYMENT_HISTORY,
      payload
    );
    console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const GetPaymentModes = async (user_id) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      user_id: user_id,
    };
    const response = await axiosInstance.post(URLS.GET_PAYMENT_TERMS, payload);

    // console.log("Payment Mode res",response);

    if (response?.data?.result[0]?.status_code === 200) {
      return response.data?.result[0]?.response;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const GetVendorUnpaidOrders = async (company_id, vendor_id) => {
  try {
    const payload = {
      // lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: company_id,
      vendor_id: Number(vendor_id),
    };
    const response = await axiosInstance.post(URLS.GET_VENDORS_UNPAID_ORDERS, payload);

    console.log("GET_VENDORS_UNPAID_ORDERS",response);

    if (response?.data?.status_code === 200) {
      return response.data?.result?.response;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const RegisterPayment = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.REGISTER_PAYMENT, payload);

    console.log("BBBBBB", response);

    if (response?.data?.result?.status_code === 200) {
      return response.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const AddBarcodeApi = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.ADD_BARCODE, payload);

    console.log("BBBBBB", response);

    if (response?.data?.result?.status_code === 200) {
      return response.data?.result;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

//  Payment List APIS

export const getPurchaseList = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_PURCHASE_LIST, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updatePOImages = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.UPLOAD_PO_IMAGE, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getPayTerms = async (company_id) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      user_id: company_id,
    };
    const response = await axiosInstance.post(URLS.GET_PAY_TERMS, payload);

    console.log("responsse data", response.data);

    return response.data?.result?.payment_terms;
  } catch (error) {
    return error;
  }
};

// In PurchaseFunctions.js
export const createPurchaseOrder = async (payload) => {
  try {
    const response = await axiosInstance.post(
      URLS.CREATE_PURCHASE_ORDER,
      payload
    );

    console.log("responsse data", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating purchase order:", error);
    throw error; // Rethrow the error for handling in the calling function
  }
};



export const getVendorDetails = async (
  company_id,
  vendor_id,
  start_date = "",
  end_date = ""
) => {
  try {
    const payload = {
      company_id: company_id,
      vendor_id: Number(vendor_id),
      start_date,
      end_date,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };

    const response = await axiosInstance.post(URLS.GET_VENDOR_INFO, payload);
    return response.data?.result?.[0]?.response;
  } catch (error) {
    return error;
  }
};

export const getVendorInventoryDetails = async (
  company_id,
  vendor_id,
) => {
  try {
    const payload = {
      company_id: company_id,
      vendor_id: Number(vendor_id),
      // lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };

    const response = await axiosInstance.post(URLS.GET_VENDOR_INVENTORY_INFO, payload);
    return response.data?.result;
  } catch (error) {
    return error;
  }
};


export const getVendorProducts = async (
  company_id,
  vendor_id,
  start_date = "",
  end_date = "",
  filter = "all",
  search = "",
  limit,
  offset,
  shortcode
) => {
  try {
    const payload = {
      company_id: company_id,
      vendor_id: Number(vendor_id),
      filter,          // 'all', 'top', 'bottom'
      search,          // search query
      short_code: shortcode,
      // start_date,
      // end_date,
      limit: limit,
      offset: offset,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };

    const response = await axiosInstance.post(URLS.GET_VENDOR_PRODUCTS, payload);
    return response.data?.result?.[0]?.response;
  } catch (error) {
    return error;
  }
};